/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetLocationsResponseAllOf,
    GetLocationsResponseAllOfFromJSON,
    GetLocationsResponseAllOfFromJSONTyped,
    GetLocationsResponseAllOfToJSON,
} from './GetLocationsResponseAllOf';
import {
    Location,
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
} from './Location';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';

/**
 * 
 * @export
 * @interface GetLocationsResponse
 */
export interface GetLocationsResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetLocationsResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetLocationsResponse
     */
    message: string;
    /**
     * 
     * @type {Array<Location>}
     * @memberof GetLocationsResponse
     */
    data: Array<Location>;
}

export function GetLocationsResponseFromJSON(json: any): GetLocationsResponse {
    return GetLocationsResponseFromJSONTyped(json, false);
}

export function GetLocationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocationsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ((json['data'] as Array<any>).map(LocationFromJSON)),
    };
}

export function GetLocationsResponseToJSON(value?: GetLocationsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ((value.data as Array<any>).map(LocationToJSON)),
    };
}

